var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThighs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "59px",
    viewBox: "0 0 57 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Thighs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-19",
    transform: "translate(-60.000000, -193.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4382325,192.969327 C66.9654677,197.990555 71.9561886,200.837287 75.4103953,201.509525 C78.864602,202.181763 82.8513247,201.185692 87.3705636,198.521315 C86.8052523,213.999822 86.5225967,225.559842 86.5225967,233.201373 C86.5225967,240.842904 86.8052523,247.109113 87.3705636,252 L69.1706428,252 C67.2089567,241.653936 65.2943221,233.073758 63.4267391,226.259465 C60.5052558,214.9604 59.5090869,203.863687 60.4382325,192.969327 Z M116.676157,193.718408 C117.510707,204.113381 116.46724,214.9604 113.545757,226.259465 C111.678174,233.073758 109.763539,241.653936 107.801853,252 L107.801853,252 L89.6019323,252 C90.1672436,247.109113 90.4498992,240.842904 90.4498992,233.201373 C90.4498992,225.559842 90.1672436,213.999822 89.6019323,198.521315 C94.1211712,201.185692 98.1078939,202.181763 101.562101,201.509525 C105.016307,200.837287 110.054326,198.240248 116.676157,193.718408 Z",
    id: "Thighs"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThighs);
export default __webpack_public_path__ + "static/media/Thighs.ac9fa3644ed354110b1547abd3747f15.svg";
export { ForwardRef as ReactComponent };